import { useMemo } from "react"
import { SIMULTANEIDADE_MAX, SIMULTANEIDADE_MIN } from "src/components/projetos/constants"
import { Projeto } from "src/components/projetos/types"
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"

interface InputSimultaneidadeProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
}

export function InputSimultaneidade({formState, setFormState}: InputSimultaneidadeProps) {
  const simultaneidadeValidacaoText = useMemo((): boolean | string =>{
    if (!formState.simultaneidade) return true
    if (Number(formState.simultaneidade || 0) > SIMULTANEIDADE_MAX) return `A simultaneidade não pode ser maior que ${SIMULTANEIDADE_MAX}%.`;
    if (Number(formState.simultaneidade || 0) < SIMULTANEIDADE_MIN) return `A simultaneidade não pode ser menor que ${SIMULTANEIDADE_MIN}%.`;
    return false
  },[formState.simultaneidade])

  return (
    <InputDecimal3
      label="* Simultaneidade (%)"
      helperText={simultaneidadeValidacaoText || "Sugestão: 25% residencial e 50% comercial"}
      margin="normal"
      decimal={2}
      error={!!simultaneidadeValidacaoText}
      maxLength={5}
      allowNegative={false}
      value={formState.simultaneidade || ''}
      onChange={(event: any) => {
        setFormState({ simultaneidade: event.target.value })
      }}
    />
  )
}